import React from 'react';
import { GolfHeaderContainer } from '../organisms/golfHeaderContainer';
import StartTimeSelectContainer from '../organisms/startTimeSelectContainer';
import { SubHeader } from '../molecules/subHeader';
import { GolfFooterContainer } from '../organisms/golfFooterContainer';
import SubHeader1 from '../../resources/image/subHeader1.png';
import { GolfSearchFooterContainer } from '../organisms/golfSearchFooterContainer';
import GolfReservationPopupContainer from '../organisms/golfReservationPopupContainer';
import { connect } from "react-redux";

class StartTimeSelectTemplate extends React.Component{
    render(){
        return(
            <div style={{height:"100%"}}>
                <GolfHeaderContainer 
                    categoryLabel1 ={"スタート時間"} Label 
                    categoryLabel2 = {"TEE TIME"} 
                    path={"/reserve/golf/searchResult"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}/>
                <SubHeader SubImage={SubHeader1}/>
                <StartTimeSelectContainer 
                    reserveType={"reserve"}
                />
                <GolfReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
            </div>
        )
    }
}
export default StartTimeSelectTemplate;